import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
    name: 'tagFilter',
    pure: false
})
export class PipeTagFilter implements PipeTransform {
    transform(_files:any[],fileBlockActive: any = false, tag: any, limit : boolean = false): any {
        if (!fileBlockActive)
            return false;
    
        var file = this.arraySearch(_files, 'file_id', fileBlockActive, true);
    
        if (!file)
            return false;

        
        if(limit){
            if(tag?.attr?.limit == undefined || Array.isArray(file.tags) && file.tags.indexOf(tag.tag_id) > -1)
                return false;
    
            var fileWithTag = _files.filter(item => item.status == 1 && Array.isArray(item.tags) && item.tags.indexOf(tag.tag_id) > -1);
    
            return fileWithTag.length >= tag.attr.limit;
        }

        let r = Array.isArray(file.tags) && file.tags.indexOf(tag.tag_id) > -1;

        return r;
    }
    arraySearch(array, key, value, returnOject: boolean = false) {
  
        for (var k in array)
          if (array.hasOwnProperty(k)) {
            if (array[k] == value || (array[k][key] != 'undefined' && array[k][key] == value))
              return returnOject ? array[k] : k;
          }
    
        return false;
      }
}